var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExercise(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 104.616,
    height: 95.126,
    viewBox: "0 0 104.616 95.126",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "icon_klangwelten",
    transform: "translate(1.075 1)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12269",
    "data-name": "Group 12269"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14895",
    "data-name": "Path 14895",
    d: "M150.493,41.938c0,12.718-8.783,23.028-19.617,23.028S111.26,54.656,111.26,41.938,126.341,20.692,130.877,2.5C135.38,20.692,150.493,29.22,150.493,41.938Z",
    transform: "translate(-79.668 -2.5)",
    fill: "none",
    stroke: "#4da2ef",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14896",
    "data-name": "Path 14896",
    d: "M140.446,124.5s-3.962,16.255,7.01,18.084",
    transform: "translate(-99.881 -89.062)",
    fill: "none",
    stroke: "#4da2ef",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14897",
    "data-name": "Path 14897",
    d: "M123.517,152.132s16.561,15.036-4.165,28.752-42.57,2.946-42.57,2.946-26.721-11.887-9.55-31.7",
    transform: "translate(-44.345 -108.669)",
    fill: "none",
    stroke: "#4da2ef",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14898",
    "data-name": "Path 14898",
    d: "M73.326,96.923s31.715,9.45,31.715,31.053S79.7,158.1,79.7,158.1,52.9,168.9,26.1,157.057s-23.473-30.12-23.473-30.12S.139,109.491,33.375,96.923",
    transform: "translate(-2.5 -69.497)",
    fill: "none",
    stroke: "#4da2ef",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExercise);
export default __webpack_public_path__ + "static/media/exercise.a4f0b62765178a58163d8dd546a4f3e8.svg";
export { ForwardRef as ReactComponent };